import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/gitlab-runner/builds/Rfteai2v/0/mprog/airport-appliance_frontend/src/app/(static)/brands/BrandContainer.js");
